const urlPrefix = '/clas';
const statementsIndividualPrefix = `${urlPrefix}/statement-report/individual`;
const statementsBulkPrefix = `${urlPrefix}/statement-report/bulk`;
const glUrlPrefix = `${urlPrefix}/clas-gl`;
const journalPrefix = `${urlPrefix}/journals`;
const trustUrlPrefix = '/trust';

export const reportUrls = {
  dashboard: {
    receivables: `${urlPrefix}/dashboard/receivables`,
    collections: `${urlPrefix}/dashboard/collections`,
    billedVsPaid: `${urlPrefix}/dashboard/billed-vs-paid`,
    submittedContracts: `${urlPrefix}/dashboard/submitted-contracts`,
    projections: `${urlPrefix}/dashboard/projections`,
  },
  arAgingReport: {
    url: `${urlPrefix}/aging-report/services`,
    emailUrl: `${urlPrefix}/aging-report/services/export-email`,
    downloadUrl: `${urlPrefix}/aging-report/services/exports`,
  },
  arAgingDetailedReport: {
    url: `${urlPrefix}/aging-report/details`,
    emailUrl: `${urlPrefix}/aging-report/details/export-email`,
    downloadUrl: `${urlPrefix}/aging-report/details/exports`,
    totalCountUrl: `${urlPrefix}/aging-report/details/count`,
  },
  pnFuneralTrustAgingSummary: {
    url: `${urlPrefix}/pn-funeral-trust-aging-report/summary`,
    emailUrl: `${urlPrefix}/pn-funeral-trust-aging-report/summary/export-email`,
    downloadUrl: `${urlPrefix}/pn-funeral-trust-aging-report/summary/exports`,
  },
  pnFuneralTrustAgingDetailedReport: {
    url: `${urlPrefix}/pn-funeral-trust-aging-report/details`,
    emailUrl: `${urlPrefix}/pn-funeral-trust-aging-report/details/export-email`,
    downloadUrl: `${urlPrefix}/pn-funeral-trust-aging-report/details/exports`,
    totalCountUrl: `${urlPrefix}/pn-funeral-trust-aging-report/details/count`,
  },
  futurePaidinFullReport: {
    url: `${urlPrefix}/future-deed-report/list`,
    emailUrl: `${urlPrefix}/future-deed-report/exports-email`,
    downloadUrl: `${urlPrefix}/future-deed-report/exports`,
    totalCountUrl: `${urlPrefix}/future-deed-report/count`,
  },
  payOffReport: {
    url: `${urlPrefix}/pay-off-report/list`,
    emailUrl: `${urlPrefix}/pay-off-report/export-email`,
    downloadUrl: `${urlPrefix}/pay-off-report/exports`,
    totalCountUrl: `${urlPrefix}/pay-off-report/count`,
    amountUrl: `${urlPrefix}/pay-off-report/check`,
  },
  payOffReportCalculate: {
    downloadUrl: `${urlPrefix}/pay-off-report/exports-individual`,
    emailUrl: `${urlPrefix}/pay-off-report/exportIndividual-email`,
  },
  interestAndFinancebyCustomer: {
    url: `${urlPrefix}/interest-finance-report/list`,
    emailUrl: `${urlPrefix}/interest-finance-report/export-email`,
    downloadUrl: `${urlPrefix}/interest-finance-report/exports`,
    totalCountUrl: `${urlPrefix}/interest-finance-report/count`,
  },
  equityOnCancelledContract: {
    url: `${urlPrefix}/equity-cancelled-contract-report/list`,
    emailUrl: `${urlPrefix}/equity-cancelled-contract-report/export-email`,
    downloadUrl: `${urlPrefix}/equity-cancelled-contract-report/exports`,
    totalCountUrl: `${urlPrefix}/equity-cancelled-contract-report/count`,
  },
  unpaidTransactionReport: {
    url: `${urlPrefix}/unpaid-transaction-report/list`,
    emailUrl: `${urlPrefix}/unpaid-transaction-report/export-email`,
    downloadUrl: `${urlPrefix}/unpaid-transaction-report/exports`,
    totalCountUrl: `${urlPrefix}/unpaid-transaction-report/count`,
  },
  individual: {
    url: `${statementsIndividualPrefix}/list`,
    summary: `${statementsIndividualPrefix}/summary`,
    emailUrl: `${statementsIndividualPrefix}/export-email`,
    downloadUrl: `${statementsIndividualPrefix}/export`,
    totalCountUrl: `${statementsIndividualPrefix}/count`,
  },
  bulk: {
    url: `${statementsBulkPrefix}/list`,
    emailUrl: `${statementsBulkPrefix}/export-email`,
    downloadUrl: `${statementsBulkPrefix}/export`,
    totalCountUrl: `${statementsBulkPrefix}/count`,
    monthlyExport: `${statementsBulkPrefix}/monthly-export`,
    monthlyExportStatus: `${statementsBulkPrefix}/monthly-export-status`,
    checkSummaryTable: `${statementsBulkPrefix}/check-summary-table`,
  },
  arAdjustmentReport: {
    url: `${urlPrefix}/ar-adjustment-report/list`,
    emailUrl: `${urlPrefix}/ar-adjustment-report/export-email`,
    downloadUrl: `${urlPrefix}/ar-adjustment-report/exports`,
    totalCountUrl: `${urlPrefix}/ar-adjustment-report/count`,
  },
  PIAExceptionReport: {
    url: `${urlPrefix}/pia-exception-report`,
    emailUrl: `${urlPrefix}/pia-exception-report/export-email`,
    downloadUrl: `${urlPrefix}/pia-exception-report/export`,
    totalCountUrl: `${urlPrefix}/pia-exception-report/count`,
  },
  salesJournal: {
    url: `${journalPrefix}/sales-journal/list`,
    downloadUrl: `${journalPrefix}/sales-journal/exports`,
    totalCountUrl: `${journalPrefix}/sales-journal/count`,
  },
  cashJournal: {
    url: `${journalPrefix}/cash-journal/list`,
    downloadUrl: `${journalPrefix}/cash-journal/exports`,
    totalCountUrl: `${journalPrefix}/cash-journal/count`,
  },
  commissionJournal: {
    url: `${journalPrefix}/commission-journal/list`,
    downloadUrl: `${journalPrefix}/commission-journal/exports`,
    totalCountUrl: `${journalPrefix}/commission-journal/count`,
  },
  generalJournal: {
    url: `${journalPrefix}/general-journal/list`,
    downloadUrl: `${journalPrefix}/general-journal/exports`,
    totalCountUrl: `${journalPrefix}/general-journal/count`,
  },
  trustDetailsReport: {
    downloadUrl: `${trustUrlPrefix}/exportContract`,
    emailUrl: `${trustUrlPrefix}/exportContract-email`,
  },
  glAccount: {
    downloadCSVUrl: `${glUrlPrefix}/glAccount`,
  },
  trustJournal: {
    url: `${journalPrefix}/trust-journal/list`,
    downloadUrl: `${journalPrefix}/trust-journal/exports`,
    totalCountUrl: `${journalPrefix}/trust-journal/count`,
  },
  trustItemsReport: {
    url: `${trustUrlPrefix}/fetch-trust-payment-allocation-items`,
    emailUrl: `${trustUrlPrefix}/exportTrustItems-email`,
    downloadUrl: `${trustUrlPrefix}/exportItems`,
  },
  negativeDueReport: {
    url: `${urlPrefix}/negative-due-report/details`,
    emailUrl: `${urlPrefix}/negative-due-report/details/export-email`,
    downloadUrl: `${urlPrefix}/negative-due-report/details/exports`,
    totalCountUrl: `${urlPrefix}/negative-due-report/details/count`,
  },
  pastDueReport: {
    url: `${urlPrefix}/over-due-exception-report/list`,
    emailUrl: `${urlPrefix}/over-due-exception-report/export-email`,
    downloadUrl: `${urlPrefix}/over-due-exception-report/exports`,
    totalCountUrl: `${urlPrefix}/over-due-exception-report/count`,
  },
  // These Routes Are For Trust Contracts
  TA: {
    downloadUrl: `${trustUrlPrefix}/exportTrustContractsList`,
  },
  CTC: {
    downloadUrl: `${trustUrlPrefix}/exportTrustContractsList`,
  },
  DTC: {
    downloadUrl: `${trustUrlPrefix}/exportTrustContractsList`,
  },
  ECC: {
    downloadUrl: `${trustUrlPrefix}/exportTrustContractsList`,
  },
  trust_monthly_report: {
    url: `${trustUrlPrefix}/fetch-trust-monthly-report-data`,
    downloadUrl: `${trustUrlPrefix}/export-trust-monthly-report-data`,
    emailUrl: `${trustUrlPrefix}/export-trust-monthly-report-data`,
  },
  trustDetailedReport: {
    url: `${trustUrlPrefix}/fetchDetailedContractAllocationReport`,
    totalCountUrl: `${trustUrlPrefix}/fetchDetailedContractAllocationReportCount`,
    downloadUrl: `${trustUrlPrefix}/export-detailed-contract-allocation-report-data`,
    emailUrl: `${trustUrlPrefix}/export-detailed-contract-allocation-report-data`,
  },
};

export const trustUrls = {
  trust_report: {
    url: `${trustUrlPrefix}/all-trust-contracts`,
    fetchdata: `${trustUrlPrefix}/fetch-trust-contract`,
    getprojectiondata: `${trustUrlPrefix}/get-projection-data`,
    trustAccount: `/trustAccount`,
    agreement: `/agreement`,
  },
};

export const accountingAutomatedReports = {
  cashInFlow: {
    url: `${urlPrefix}/cash-flow`,
  },
  revenue: {
    url: `${urlPrefix}/total-revenue`,
  },
  balanceDue: {
    url: `${urlPrefix}/account-receivables`,
  },
};

export const commonFilters = {
  url: `${urlPrefix}/dropdowns`,
  dashboardUrl: `${urlPrefix}/dashboard/dropdowns`,
};
export const extraARFilters = {
  url: `${urlPrefix}/aging-dropdown`,
};

export const AccountTypeDefinition = {
  listing: `${glUrlPrefix}/account-type/list`,
  add: `${glUrlPrefix}/account-type/create`,
  edit: `${glUrlPrefix}/account-type/edit`,
};

export const SegmentDefinition = {
  listing: `${glUrlPrefix}/account-segment/search`,
  add: `${glUrlPrefix}/account-segment/create`,
  edit: `${glUrlPrefix}/account-segment/edit`,
  data: `${glUrlPrefix}/account-segment/data`,
  createData: `${glUrlPrefix}/account-segment/data/create`,
  editData: `${glUrlPrefix}/account-segment/data/edit`,
  dataCount: `${glUrlPrefix}/account-segment/data-count`,
};

export const GLTemplate = {
  listing: `${glUrlPrefix}/template/list`,
  add: `${glUrlPrefix}/template/create`,
  edit: `${glUrlPrefix}/template/edit`,
  typesListing: `${glUrlPrefix}/gltemplate-Type/list`,
  categoriesListing: `${glUrlPrefix}/gltemplate-Category/list`,
  transactionsTypeListing: `${glUrlPrefix}/gltemplate-transactionType/list`,
  individualTemplate: `${glUrlPrefix}/template/individual`,
  templateTotalCount: `${glUrlPrefix}/template/count`,
  templateIdSearch: `${glUrlPrefix}/template/identification-number/search`,
  templateNameSearch: `${glUrlPrefix}/template/template-name/search`,
  accountNumberSearch: `${glUrlPrefix}/account-number/search`,
};

export const AccountNumber = {
  listing: `${glUrlPrefix}/account-number/list`,
  add: `${glUrlPrefix}/account-number/create`,
  edit: `${glUrlPrefix}/account-number/edit`,
  count: `${glUrlPrefix}/account-number/count`,
  entityList: `${glUrlPrefix}/account-entity/list`,
  searchSegment: `${glUrlPrefix}/segment-value/search`,
};

export const JournalGLConfig = {
  eventList: `${glUrlPrefix}/events/list`,
  listData: `${glUrlPrefix}/gltable/data`,
  updateData: `${glUrlPrefix}/glconfiguration/update`,
  cancelReasonList: `${glUrlPrefix}/reasons/list`,
  glExceptionData: `${glUrlPrefix}/gl-exceptions`,
  glExceptionDataCount: `${glUrlPrefix}/gl-exceptions/count`,
  glExceptionRegenerate: `${glUrlPrefix}/gl-exceptions/regenerate`,
};
